var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              { staticClass: "modal-card-title" },
              [_vm._t("text-title")],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c("article", { staticClass: "message is-info" }, [
              _c("div", { staticClass: "message-body" }, [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Quote Labour Times"),
                    ]),
                    _c(
                      "span",
                      { staticClass: "has-text-weight-bold has-text-primary" },
                      [_vm._v(_vm._s(_vm.quoteTimesType))]
                    ),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Vehicle Body Style"),
                    ]),
                    _c(
                      "span",
                      { staticClass: "has-text-weight-bold has-text-primary" },
                      [_vm._v(_vm._s(_vm.bodyShape))]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm.finishFetchingTemplates && !_vm.isTemplateListNonEmpty
              ? _c("div", { staticClass: "field" }, [
                  _c("span", { staticClass: "has-text-danger is-italic" }, [
                    _c("i", { staticClass: "mdi mdi-alert-outline" }),
                    _vm._v(
                      " No templates available. Please contact your admin to create a new template under "
                    ),
                    _c("span", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Quote > Quote Template."),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.label)),
              ]),
              _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedTemplate,
                        expression: "selectedTemplate",
                      },
                    ],
                    attrs: {
                      disabled:
                        _vm.finishFetchingTemplates &&
                        !_vm.isTemplateListNonEmpty,
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedTemplate = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "null", disabled: "" } }, [
                      _vm._v("Select"),
                    ]),
                    _vm._l(_vm.templates, function (template, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: template } },
                        [_vm._v(_vm._s(template.name))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  attrs: { disabled: !_vm.isTemplateSelected },
                  on: { click: _vm.add },
                },
                [_vm._v("Apply")]
              ),
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.close } },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }